module.exports = __webpack_public_path__ + "img/[可爱].e6f52d5e.svg";